/**
 * Root translation key.
 */
export const APP_KEY = 'certified_banner';
